import { Link } from "react-router-dom";

/** Small legal footer for app + public pages. `tone` = "light" (bone pages) | "dark" (green pages). */
export default function LegalFooter({ tone = "light" }) {
  const base = tone === "dark" ? "text-[#9db4a8]" : "text-[#8a8272]";
  const link = tone === "dark" ? "text-[#e8e3d5]" : "text-[#5c5c5c]";
  return (
    <footer
      className={`py-6 text-center font-mono text-[9px] uppercase tracking-[0.2em] ${base}`}
      data-testid="legal-footer"
    >
      Pins · pinmy.travel ·{" "}
      <Link to="/install" className={`underline underline-offset-2 ${link}`} data-testid="footer-install-link">
        Get the app
      </Link>{" "}
      ·{" "}
      <Link to="/terms" className={`underline underline-offset-2 ${link}`} data-testid="footer-terms-link">
        Terms
      </Link>{" "}
      ·{" "}
      <Link to="/privacy" className={`underline underline-offset-2 ${link}`} data-testid="footer-privacy-link">
        Privacy
      </Link>
    </footer>
  );
}
